import React, { useState, useEffect } from "react";
import Table from "../../styled-components/table/table";
import { useHistory } from "react-router-dom";
import * as Style from "./styles/rates-of-return";
import { defaultStyles } from "../../../constants/style-constants/utils";
import { Text } from "../../styled-components/text";
import { EditOutlined } from "@ant-design/icons";
import NewLoader from "../../styled-components/loader/NewLoader";
import TAX_AND_INFLATION_API from "../../../apis/tax_and_inflation.api";
import ModalVideo from "../../../newComponents/ModuleVideos/ModalVideo";
function RatesOfReturn() {
  const history = useHistory();
  const { styles } = defaultStyles;
  const [loading, setLoading] = useState(false);
  const [rateOfReturnData, setRateOfReturnData] = useState(null);
  const tableBodyDataUserDefined = [{ hmy: "User Defined", hb: "0", lb: "0", ea: "0%" }];
  const [userDefinedData, setUserDefinedData] = useState(tableBodyDataUserDefined);

  const tableColumnsDataUserDefined = [
    { id: "7", name: "User Defined", class: { width: "10rem" } },
    { id: "1", name: "How Many Years", class: { width: "10rem" } },
    { id: "5", name: "Start Year", class: { width: "10rem" } },
    { id: "6", name: "Average", class: { width: "10rem" } },
  ];


  const tableColumnsData = [
    { id: "7", name: "User Defined", class: { width: "10rem" } },
    { id: "1", name: "How Many Years", class: { width: "10rem" } },
    { id: "2", name: "High Band", class: { width: "10rem" } },
    { id: "3", name: "Low Band", class: { width: "10rem" } },
    { id: "4", name: "Expected Average", class: { width: "10rem" } },
    { id: "5", name: "Start Year", class: { width: "10rem" } },
    { id: "6", name: "Average", class: { width: "10rem" } },
  ];

  const tableBodyData = [
    { hmy: "15", hb: "8", lb: "6", ea: "80", sy: "209", a: "85", as: "46" },
    { hmy: "15", hb: "9", lb: "6", ea: "85", sy: "2019", a: "90", as: "46" },
    { hmy: "15", hb: "9", lb: "6", ea: "85", sy: "2019", a: "90", as: "46" },
    { hmy: "15", hb: "9", lb: "6", ea: "85", sy: "2019", a: "90", as: "46" },
    { hmy: "15", hb: "9", lb: "6", ea: "85", sy: "2019", a: "90", as: "46" },
    { hmy: "15", hb: "9", lb: "6", ea: "85", sy: "2019", a: "90", as: "46" },
    { hmy: "15", hb: "9", lb: "6", ea: "85", sy: "2019", a: "90", as: "46" },
    { hmy: "15", hb: "9", lb: "6", ea: "85", sy: "2019", a: "90", as: "46" },
    { hmy: "15", hb: "9", lb: "6", ea: "85", sy: "2019", a: "90", as: "46" },
    { hmy: "15", hb: "9", lb: "6", ea: "85", sy: "2019", a: "90", as: "46" },
    { hmy: "15", hb: "9", lb: "6", ea: "85", sy: "2019", a: "90", as: "46" },
    { hmy: "15", hb: "9", lb: "6", ea: "85", sy: "2019", a: "90", as: "46" },
    { hmy: "15", hb: "9", lb: "6", ea: "85", sy: "2019", a: "90", as: "46" },
    { hmy: "15", hb: "9", lb: "6", ea: "85", sy: "2019", a: "90", as: "46" },
    { hmy: "15", hb: "9", lb: "6", ea: "85", sy: "2019", a: "90", as: "46" },
  ];

  const staticReturnRateObj = {
    Static: rateOfReturnData && rateOfReturnData.staticPercentage,
  };

  const professionalPredictionsObj = {
    "Professional Predictions": "William Forsyth Sharpe",
    "Prediction File": "abc.doc",
  };

  const allData = [
    { title: "Static Return Rate", data: staticReturnRateObj },
    // { title: "Monte Carlo", data: professionalPredictionsObj },
  ];
  const getRateofReturnDetails = async () => {
    try {
      setLoading(true);
      let data = await TAX_AND_INFLATION_API.getRatesofReturn();
      if (data && data.data) {
        setRateOfReturnData(data.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while fetching Rate of Retrun Details", error);
    }
  };
  const getUserDefinedDetails = async () => {
    try {
      setLoading(true);
      let data = await TAX_AND_INFLATION_API.getUserDefinedDetails();
      if (data && data.data) {
        // setRateOfReturnData(data.data);
        const response={
          userDefined:"User Defined",
          years:data.data.totalRows ? data.data.totalRows : 0,
          startYear:data.data.minimumYear ? data.data.minimumYear : 0,
          averagePercentage:(data.data.averagePercentage ? (data.data.averagePercentage).toFixed(2) : 0) + "%",
        }
        setUserDefinedData([response]);
      }else{
        setUserDefinedData(tableBodyDataUserDefined);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while fetching Rate of Retrun Details", error);
    }
  };
  const getAll = async () => {
    await getRateofReturnDetails();
    await getUserDefinedDetails();
  };

  useEffect(() => {
    getAll();
  }, []);

  return (
    <div style={{position:"relative"}}>
      <div className="tax-inflation-header-container">
        <h3>Rates of Return </h3>
        { localStorage.getItem('role') &&  JSON.parse(localStorage.getItem('role')) !== "Financial Advisor Client" && (<button onClick={() => history.push("/rates_of_return_edit/1")}>
          <EditOutlined />
          <p>Edit</p>
        </button>)}
      </div>
      <ModalVideo module="Rates of Return" autoOpen={true} />
      <div style={{ padding: "1rem" }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "1rem",
            background: "white",
            padding: "1rem",
            justifyContent: "center",
          }}
        >
          {allData &&
            allData.map((data, index) => (
              <div
                key={index}
                className="tax-inflation-cards-container"
                style={{
                  borderRadius: "10px",
                  overflow: "hidden",
                }}
              >
                <Style.TableHeader>{data.title}</Style.TableHeader>
                {data &&
                  Object.keys(data.data).map((key, index) => (
                    <Style.TableBodyRow
                      key={index}
                      backgroundColor={
                        (index + 1) % 2 === 0 ? "white" : "#EBF1FF"
                      }
                      style={{
                        paddingInline: "8px",
                        display: "flex",
                        flexWrap: "wrap",
                      }}
                    >
                      <Text
                        style={styles.text.labelBoldText}
                        width="13rem"
                        color="rgba(0,0,0,.65)"
                      >
                        {key}{" "}
                      </Text>

                      <Text width="13rem" color="rgba(0,0,0,.65)">
                        {data.data[key]}
                      </Text>
                    </Style.TableBodyRow>
                  ))}
              </div>
            ))}
        </div>
      </div>
      <div style={{ margin: "3rem 1rem" }}>
        <Table
          tableColumnsData={tableColumnsDataUserDefined}
          tableBodyData={userDefinedData && userDefinedData}
        />
      </div>
      {/*  <div style={{ margin: "3rem 1rem" }}>
        <Table
          tableColumnsData={tableColumnsData}
          tableBodyData={tableBodyData}
        />
      </div> */}
      <NewLoader isLoading={loading} />
    </div>
  );
}

export default RatesOfReturn;
